module.exports = __webpack_public_path__ + "img/264.b4708849.jpg";